import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

const MetricSkeleton = () => (
  <Card className='@container/card'>
    <CardHeader className='relative'>
      <CardDescription className='flex items-center gap-2'>
        <Skeleton className='h-4 w-4' />
        <Skeleton className='h-4 w-24' />
      </CardDescription>
      <CardTitle className='@[250px]/card:text-3xl text-2xl font-semibold'>
        <Skeleton className='h-8 w-32' />
      </CardTitle>
    </CardHeader>
  </Card>
);

export default MetricSkeleton;
